/* import __COLOCATED_TEMPLATE__ from './phone-one-time-passcode.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import Component from '@glimmer/component';
import { type ComponentLike } from '@glint/template';
import type ConnectionPoint from 'embercom/models/operator/visual-builder/connection-point';
import type PhoneOneTimePasscode from 'embercom/models/operator/visual-builder/step/phone-one-time-passcode';
import type EditorState from 'embercom/objects/workflows/graph-editor/editor-state';
import type { Yieldable } from 'ember-concurrency';

interface Signature {
  Args: {
    step: PhoneOneTimePasscode;
    editorState: EditorState;
    readOnly: boolean;
    isTemplatePreview?: boolean;
    connectionPointComponent: ComponentLike<{ connectionPoint: ConnectionPoint }>;
    updateConnectionPoints: (node: Node) => Generator<Yieldable<void>, void, unknown>;
  };
  Element: HTMLDivElement;
}

export default class PhoneOneTimePasscodeNodeItem extends Component<Signature> {
  get fallbackBranch(): ConnectionPoint {
    return this.args.step.outwardConnectionPoints.firstObject!;
  }

  get shouldShowOutputError() {
    return (
      this.args.editorState.shouldShowValidations &&
      this.args.step.validations.attrs.outwardConnectionPoints &&
      !this.args.step.validations.attrs.outwardConnectionPoints.isValid
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::PhoneOneTimePasscode': typeof PhoneOneTimePasscodeNodeItem;
    'workflows/graph-editor/node-items/steps/phone-one-time-passcode': typeof PhoneOneTimePasscodeNodeItem;
  }
}
